import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

const propTypes = {
    /**
   * Bottom gutter of the StandardSection
   * Available options: "standard", "mini"
   */ gutterBottom: PropTypes.oneOf([
        'standard',
        'mini'
    ])
};
/**
 * @deprecated Use Spacing instead, which provides updated styling and functionality.
 */ const StandardSection = deprecatedComponent({
    displayName: 'StandardSection',
    description: 'StandardSection is deprecated; use Spacing instead, which provides updated styling and functionality',
    root: createComponent({
        displayName: 'StandardSection',
        root: 'section',
        propTypes,
        propConfig: {
            classNames (props) {
                const classNameSet = new Set([
                    'swan-standard-section'
                ]);
                const { gutterBottom = 'standard' } = props;
                if (gutterBottom === 'mini') classNameSet.add('swan-standard-section-mini');
                return classNameSet;
            }
        }
    })
});
StandardSection.defaultProps = {
    gutterBottom: 'standard'
};

export { StandardSection };
